import { render, staticRenderFns } from "./IconSvgXls.vue?vue&type=template&id=66ba2e41&scoped=true&"
import script from "./IconSvgXls.vue?vue&type=script&lang=js&"
export * from "./IconSvgXls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ba2e41",
  null
  
)

export default component.exports